<script lang="ts" setup>
import { getCSSVariable } from '@/helpers/utils'

interface Props {
  align: 'left' | 'right'
  variant: 'outline' | 'filled'
  color: string
}

withDefaults(defineProps<Props>(), {
  align: 'left',
  variant: 'filled',
  color: getCSSVariable('darkest'),
})

defineOptions({
  inheritAttrs: false,
})
</script>

<template>
  <svg
    v-if="align === 'left' && variant === 'filled'"
    v-bind="$attrs"
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="1280.000000pt"
    height="1740.000000pt"
    viewBox="0 0 1280.000000 1740.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,1740.000000) scale(0.100000,-0.100000)"
      :fill="color"
      stroke="none"
    >
      <path
        d="M6933 17283 c-917 -1102 -1448 -2326 -1622 -3743 -56 -449 -72 -736
          -96 -1655 -40 -1530 -89 -1982 -280 -2573 l-35 -108 -202 -155 c-311 -239
          -506 -382 -688 -503 -870 -583 -1708 -898 -2675 -1005 -298 -33 -460 -42 -907
          -48 l-428 -6 0 -856 0 -857 112 -103 c354 -325 570 -598 1188 -1501 145 -212
          320 -464 388 -560 834 -1166 1711 -2087 2205 -2315 69 -32 169 -57 191 -49 13
          5 12 37 -15 334 -120 1371 -491 2539 -1092 3440 -179 269 -338 463 -561 685
          -251 251 -464 411 -711 536 l-131 66 185 17 c975 88 1812 7 2556 -247 652
          -223 1230 -594 1629 -1047 218 -248 313 -393 512 -780 593 -1158 1179 -1994
          1914 -2731 521 -522 1038 -910 1585 -1189 336 -170 720 -304 944 -326 l64 -7
          -6 204 c-37 1129 -314 2213 -795 3114 -291 545 -637 1015 -1082 1469 -589 600
          -1236 1066 -2065 1486 -808 409 -1717 724 -2692 931 l-153 32 193 100 c712
          367 1607 937 2356 1501 139 105 261 196 270 203 13 9 39 6 122 -13 411 -93
          830 -138 1289 -137 317 0 514 13 795 54 682 98 1345 343 1771 654 163 118 517
          497 743 795 450 592 821 1348 1001 2041 43 166 90 395 90 436 l0 26 -107 -7
          c-720 -46 -2212 -236 -2808 -357 -358 -73 -799 -254 -1255 -517 -561 -323
          -1164 -757 -2172 -1564 -192 -153 -348 -276 -348 -273 0 3 45 53 101 113 138
          146 332 378 457 547 658 883 1028 1842 1134 2935 17 181 18 910 0 1080 -79
          766 -241 1415 -515 2060 -74 175 -228 482 -244 487 -7 3 -56 -49 -110 -114z"
      />
    </g>
  </svg>
  <svg
    v-if="align === 'left' && variant === 'outline'"
    v-bind="$attrs"
    width="265"
    height="334"
    viewBox="0 0 265 334"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M-2.26663 108.949C19.2661 120.055 42.3136 131.942 83.3719 125.092C87.7267 124.366 92.0681 123.588 96.3846 122.778C107.525 112.474 114.44 99.8246 126.621 77.5432C126.834 77.1537 127.049 76.7612 127.265 76.3658C140.358 52.4185 158.16 20.6418 204.935 1.70453C205.951 23.8499 197.208 94.4082 122.129 117.655C122.327 117.614 122.525 117.574 122.723 117.533C158.553 110.186 190.84 103.565 212.451 110.4C235.903 117.819 256.253 126.093 263.496 129.303C253.808 142.777 233.509 160.638 206.5 168.502C194.683 171.942 161.671 170.204 130.853 143.655C119.973 145.858 91.8204 150.157 66.256 149.736C90.6336 169.216 166.529 236.319 118.755 332.906C104.996 323.916 77.8826 288.266 79.5057 217.586C79.7278 200.33 69.9407 163.764 13.722 142.569C24.2258 154.248 38.7111 192.318 12.6219 251.163C9.70951 250.286 2.17968 240.09 -4.64052 206.326C-7.01435 194.575 -8.25562 184.382 -9.37459 175.194C-12.2743 151.383 -14.3526 134.317 -33.1892 114.342L-17.5623 101.434C-12.4021 103.721 -7.377 106.313 -2.26663 108.949Z"
      :stroke="color"
    />
  </svg>

  <svg
    v-if="align === 'right' && variant === 'filled'"
    v-bind="$attrs"
    width="175"
    height="214"
    viewBox="0 0 175 214"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M171.272 69.9571C157.384 77.0533 142.519 84.6486 116.107 80.139C113.305 79.6607 110.513 79.1493 107.736 78.6176C100.59 71.9577 96.1696 63.7981 88.3835 49.4257C88.2474 49.1745 88.1102 48.9213 87.972 48.6663C79.6026 33.2193 68.221 12.721 38.1584 0.416541C37.4502 14.6691 42.9053 60.109 91.177 75.2568C91.0496 75.2302 90.9222 75.2035 90.7949 75.1769C67.7488 70.3595 46.9822 66.0185 33.0544 70.3659C17.9398 75.0837 4.82064 80.3601 0.150372 82.4086C6.3534 91.1054 19.3763 102.653 36.7427 107.781C44.3406 110.024 65.5948 108.986 85.4973 91.9718C92.4958 93.4161 110.607 96.2525 127.064 96.044C111.324 108.524 62.3059 151.532 92.8217 213.822C101.701 208.069 119.241 185.188 118.369 139.687C118.268 128.579 124.658 105.065 160.898 91.5594C154.108 99.0515 144.69 123.522 161.34 161.464C163.217 160.907 168.089 154.362 172.562 132.645C174.118 125.086 174.942 118.528 175.685 112.616C177.61 97.2968 178.989 86.3165 191.164 73.5046L181.136 65.1576C177.809 66.617 174.568 68.273 171.272 69.9571Z"
      :fill="color"
    />
  </svg>
  <svg
    v-if="align === 'right' && variant === 'outline'"
    v-bind="$attrs"
    width="176"
    height="237"
    viewBox="0 0 176 237"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M171.867 94.4285C154.599 95.5107 136.117 96.6691 113.459 115.912C111.056 117.953 108.68 120.02 106.331 122.098C103.277 132.496 103.674 142.783 104.371 160.904C104.384 161.221 104.396 161.54 104.408 161.861C105.157 181.338 105.888 207.338 84.1559 236.085C75.4189 222.883 54.9251 176.43 92.4279 134.671C92.3213 134.768 92.2148 134.866 92.1084 134.963C72.838 152.596 55.4736 168.484 39.7223 172.212C22.6287 176.258 7.12358 178.642 1.50772 179.329C2.50901 167.52 8.40708 149.134 22.0812 134.418C28.0636 127.979 48.9356 116.949 77.5534 121.931C83.4159 116.594 99.0968 103.644 114.921 94.5347C92.8409 91.5262 21.7333 78.2035 15.6268 1.49481C27.3548 1.9638 57.0363 13.8815 81.9388 57.8C88.1252 68.4583 107.522 87.2858 149.748 79.6789C139.031 76.3688 116.203 58.3411 110.633 12.7118C112.74 12.1826 121.091 15.6733 137.643 33.8702C143.404 40.2037 147.899 45.9966 151.952 51.2186C162.453 64.7509 169.98 74.4502 188.845 79.7923L183.996 93.4301C179.995 93.9191 175.965 94.1716 171.867 94.4285Z"
      :stroke="color"
    />
  </svg>
</template>

<style lang="scss" scoped></style>
